import TID1500MeasurementReport from "./TID1500MeasurementReport.js";
import TID1501MeasurementGroup from "./TID1501MeasurementGroup.js";

const TID1500 = {
    TID1500MeasurementReport,
    TID1501MeasurementGroup
};

export { TID1500MeasurementReport, TID1501MeasurementGroup };

export default TID1500;
